enum DriverContractListingByRailyFilterType {
  BILLING_MODEL = "BILLING_MODEL",
  TAXI_CORPORATION = "TAXI_CORPORATION",
}

export default DriverContractListingByRailyFilterType;
